import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useEffect } from 'react';

import {
  GetOutpatientQuestionnaireEntryDetailDocument,
  SendOutpatientQuestionnaireEntryNotificationDocument,
} from '~/graphql/generated/graphql';
import { outpatientQuestionnaireNotifyConfirmModalState } from '~/state/reception/atoms';

export const useNotifyOutpatientQuestionnaireEntry = () => {
  const { outpatientQuestionnaireEntryId } = useAtomValue(
    outpatientQuestionnaireNotifyConfirmModalState,
  );

  const resetState = useResetAtom(outpatientQuestionnaireNotifyConfirmModalState);
  const [notifyOutpatientQuestionnaireEntry, { data, loading: notifying, error }] = useMutation(
    SendOutpatientQuestionnaireEntryNotificationDocument,
    {
      refetchQueries: [
        {
          query: GetOutpatientQuestionnaireEntryDetailDocument,
          variables: { id: outpatientQuestionnaireEntryId },
        },
      ],
    },
  );

  useEffect(() => {
    if (!data?.notifyOutpatientQuestionnaireEntry?.outpatientQuestionnaireEntry) return;
    resetState();
  }, [data, resetState]);

  return { notifyOutpatientQuestionnaireEntry, notifying, error };
};
